export const Chat = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 23H6C4.34315 23 3 21.6569 3 20V8C3 6.34315 4.34315 5 6 5H26C27.6569 5 29 6.34315 29 8V20C29 21.6569 27.6569 23 26 23H20.5L17 29.5" stroke="currentColor" stroke-width="2"/>
<path d="M8 11H24" stroke="currentColor" stroke-width="2"/>
<path d="M8 17H18" stroke="currentColor" stroke-width="2"/>
</svg>`;
